export const TOGGLE_USER_LIMIT_FOR_DASHBOARD = 'TOGGLE_USER_LIMIT_FOR_DASHBOARD';
export const SET_ACTIVE_USER_ID = 'SET_ACTIVE_USER_ID';
